import { render, staticRenderFns } from "./rent-services.vue?vue&type=template&id=1b04fd9f&scoped=true&"
import script from "./rent-services.vue?vue&type=script&lang=js&"
export * from "./rent-services.vue?vue&type=script&lang=js&"
import style0 from "./rent-services.vue?vue&type=style&index=0&id=1b04fd9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b04fd9f",
  null
  
)

export default component.exports